import styled from '@emotion/styled'

const DialogBarHeader = styled.div`  
  font-weight: 700;
  opacity: 0.9;
  box-shadow: 0 0 8px rgba(53, 58, 82, 0.08);
  padding: 16px;
`
export default DialogBarHeader;
